/*
 * Caviar Boutique — эмират доставки и наличие по складам на сайте Shopify (тема Ella 6.7).
 *
 * То же поведение, что в приложении:
 *   • эмират доставки выбирается своим выпадающим меню (не системным <select>):
 *     в окне при каждом новом визите (раз за сессию браузера), в шапке и в
 *     предупреждении корзины; в окне заранее выбран прошлый эмират, при первом
 *     визите — эмират по IP или Дубай; закрыть окно значит оставить выбранный;
 *   • Абу-Даби торгует со своего склада, прочие эмираты — со склада Дубая;
 *   • товара нет (или не хватает) на складе выбранного эмирата — «В корзину»
 *     и «Купить сейчас» неактивны, под кнопкой подпись; в корзине —
 *     предупреждение и блокировка перехода к оформлению;
 *   • выбранный эмират пишется в атрибуты корзины («Delivery emirate») и виден в заказе.
 *
 * Разбивку по складам берём из функции storefrontStock (Firebase): витрина
 * Shopify её не отдаёт. Нет данных по товару или функция недоступна — ничего
 * не блокируем, работает обычное наличие Shopify.
 *
 * Подключение: assets/caviar-emirate.js + строка в layout/theme.liquid перед </body>:
 *   <script src="{{ 'caviar-emirate.js' | asset_url }}" defer></script>
 */
(function () {
  "use strict";
  if (window.__caviarEmirate) return;
  window.__caviarEmirate = true;

  var API = "https://us-central1-caviar-boutique-5ac06.cloudfunctions.net/storefrontStock";
  var STORAGE_KEY = "cb_delivery_emirate";
  // Окно спрашивает эмират при каждом новом визите: отметка живёт до закрытия вкладки/браузера.
  var ASKED_KEY = "cb_emirate_asked";
  var DEFAULT_EMIRATE = "Dubai";
  // Подсказка по IP для окна первого визита (ipapi.co через нашу функцию).
  // Раньше там всегда стоял Дубай, и покупатель из Абу-Даби, закрыв окно,
  // видел наличие склада Дубая (заказ #4582, 08.10.2026).
  var GEO_API = "https://us-central1-caviar-boutique-5ac06.cloudfunctions.net/geoEmirate";
  var EMIRATES = ["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Umm Al Quwain", "Ras Al Khaimah", "Fujairah"];
  var ACCENT = "#124e84";
  var DANGER = "#b3261e";
  var CART_ATTRIBUTE = "Delivery emirate";
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  var lang = String((window.Shopify && Shopify.locale) || document.documentElement.lang || "en").slice(0, 2);
  if (lang !== "ar" && lang !== "ru") lang = "en";

  var NAMES = {
    en: {},
    ar: { "Abu Dhabi": "أبوظبي", Dubai: "دبي", Sharjah: "الشارقة", Ajman: "عجمان", "Umm Al Quwain": "أم القيوين", "Ras Al Khaimah": "رأس الخيمة", Fujairah: "الفجيرة" },
    ru: { "Abu Dhabi": "Абу-Даби", Dubai: "Дубай", Sharjah: "Шарджа", Ajman: "Аджман", "Umm Al Quwain": "Умм-эль-Кайвайн", "Ras Al Khaimah": "Рас-эль-Хайма", Fujairah: "Фуджейра" },
  };
  var T = {
    en: {
      deliverTo: "Deliver to",
      title: "Where should we deliver?",
      hint: "Product availability depends on the emirate. You can change it anytime in the header.",
      emirate: "Emirate",
      save: "Continue",
      out: "Out of stock in {emirate}",
      onlyLeft: "Only {n} left in {emirate}",
      cartTitle: "Not available for delivery to {emirate}",
      cartLeft: "only {n} left",
      cartNone: "out of stock",
      cartHint: "Change the emirate or remove these items to continue.",
      change: "Change emirate:",
    },
    ar: {
      deliverTo: "التوصيل إلى",
      title: "إلى أين نوصل طلبك؟",
      hint: "يعتمد توفر المنتجات على الإمارة. يمكنك تغييرها في أي وقت من أعلى الصفحة.",
      emirate: "الإمارة",
      save: "متابعة",
      out: "غير متوفر في {emirate}",
      onlyLeft: "المتبقي {n} فقط في {emirate}",
      cartTitle: "غير متوفر للتوصيل إلى {emirate}",
      cartLeft: "المتبقي {n} فقط",
      cartNone: "غير متوفر",
      cartHint: "غيّر الإمارة أو أزل هذه المنتجات للمتابعة.",
      change: "تغيير الإمارة:",
    },
    ru: {
      deliverTo: "Доставка:",
      title: "Куда доставить заказ?",
      hint: "Наличие товаров зависит от эмирата. Поменять можно в любой момент в шапке сайта.",
      emirate: "Эмират",
      save: "Продолжить",
      out: "Нет в наличии: {emirate}",
      onlyLeft: "Осталось {n} шт.: {emirate}",
      cartTitle: "Нет в наличии для доставки: {emirate}",
      cartLeft: "осталось {n}",
      cartNone: "нет на складе",
      cartHint: "Смените эмират или уберите эти товары, чтобы продолжить.",
      change: "Сменить эмират:",
    },
  }[lang];

  function name(e) { return NAMES[lang][e] || e; }
  function fmt(s, vars) { return s.replace(/\{(\w+)\}/g, function (_, k) { return vars[k]; }); }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // ── Эмират ───────────────────────────────────────────────────────────────
  function stored() {
    try { var v = localStorage.getItem(STORAGE_KEY); return EMIRATES.indexOf(v) >= 0 ? v : null; } catch (e) { return null; }
  }
  function currentEmirate() { return stored() || DEFAULT_EMIRATE; }

  /** Спрашивали ли в этот визит. Нет доступа к sessionStorage — спрашиваем, только если эмират не выбран. */
  function askedThisVisit() {
    try { return sessionStorage.getItem(ASKED_KEY) === "1"; } catch (e) { return !!stored(); }
  }
  function markAsked() {
    try { sessionStorage.setItem(ASKED_KEY, "1"); } catch (e) { /* приватный режим */ }
  }
  function stockKey(e) { return e === "Abu Dhabi" ? "abuDhabi" : "dubai"; }

  function setEmirate(e) {
    try { localStorage.setItem(STORAGE_KEY, e); } catch (err) { /* приватный режим — живём без памяти */ }
    syncCartAttribute();
    refreshAll();
  }

  // ── Стили ────────────────────────────────────────────────────────────────
  var style = document.createElement("style");
  style.textContent =
    // Кнопка-«пилюля» в шапке: ширина по содержимому (системный <select> тянулся
    // по самому длинному эмирату — после «Dubai» оставалась пустота).
    ".cbe-dd{appearance:none;-webkit-appearance:none;display:inline-flex!important;align-items:center;gap:6px;box-sizing:border-box;margin:0;font:inherit!important;line-height:1!important;letter-spacing:0!important;text-transform:none!important;white-space:nowrap;cursor:pointer;box-shadow:none!important;min-width:0!important;min-height:0!important;outline:none;-webkit-tap-highlight-color:transparent}" +
    ".cbe-pill{border:1px solid #d9dde3!important;border-radius:999px!important;padding:0 12px!important;height:34px!important;width:auto!important;background:#fff!important;color:" + ACCENT + "!important;font-size:13px!important;margin-inline-end:14px;align-self:center}" +
    ".cbe-pill:hover,.cbe-pill:focus-visible,.cbe-dd[aria-expanded=true]{border-color:" + ACCENT + "!important}" +
    ".cbe-pill .cbe-pin{width:14px;height:14px;flex:none}" +
    ".cbe-pill .cbe-label{color:#555}" +
    ".cbe-dd .cbe-val{font-weight:600;color:#03273f}" +
    // Тема Ella заливает все svg цветом — стрелка и галочка превращались в треугольники.
    ".cbe-chevron{width:10px!important;height:10px!important;flex:none;margin-inline-start:2px;transition:transform .15s;fill:none!important;stroke:currentColor!important}" +
    ".cbe-menu li svg{fill:none!important;stroke:currentColor!important}" +
    ".cbe-dd[aria-expanded=true] .cbe-chevron{transform:rotate(180deg)}" +
    // Меню: своё, в цветах сайта; висит над страницей и над окном выбора.
    ".cbe-menu{position:fixed;z-index:2147483001;margin:0;padding:6px;list-style:none;background:#fff;border:1px solid #e3e7ee;border-radius:12px;box-shadow:0 12px 32px rgba(3,39,63,.16);max-height:340px;overflow-y:auto;font-family:inherit;font-size:14px;color:#03273f;box-sizing:border-box;text-align:start}" +
    ".cbe-menu li{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0;padding:11px 12px;border-radius:8px;cursor:pointer;outline:none;line-height:1.2;list-style:none}" +
    ".cbe-menu li:hover,.cbe-menu li:focus{background:#eef3f8}" +
    ".cbe-menu li[aria-selected=true]{font-weight:600;color:" + ACCENT + "}" +
    ".cbe-menu li svg{width:14px;height:14px;flex:none;visibility:hidden}" +
    ".cbe-menu li[aria-selected=true] svg{visibility:visible}" +
    ".cbe-overlay{position:fixed;inset:0;background:rgba(3,39,63,.45);z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px}" +
    ".cbe-modal{background:#fff;border-radius:16px;max-width:400px;width:100%;padding:24px;box-shadow:0 10px 40px rgba(0,0,0,.2);text-align:start;color:#222}" +
    ".cbe-modal h3{margin:0 0 6px;font-size:20px;line-height:1.3;color:#03273f}" +
    ".cbe-modal p{margin:0 0 16px;color:#666;font-size:14px;line-height:1.45}" +
    ".cbe-field{display:block;margin-bottom:16px}" +
    ".cbe-field small{display:block;font-size:12px;color:#666;margin-bottom:6px}" +
    ".cbe-field .cbe-dd{width:100%!important;height:46px!important;justify-content:space-between;border:1px solid #d9dde3!important;border-radius:10px!important;padding:0 14px!important;background:#fff!important;font-size:15px!important}" +
    ".cbe-field .cbe-val{font-weight:500}" +
    ".cbe-field .cbe-chevron{color:" + ACCENT + "}" +
    ".cbe-save{width:100%;height:46px;border:0;border-radius:10px;background:" + ACCENT + ";color:#fff;font:inherit;font-size:15px;font-weight:600;cursor:pointer}" +
    ".cbe-strip{display:flex;justify-content:center;padding:2px 0 8px}" +
    ".cbe-strip .cbe-pill{margin:0}" +
    ".cbe-cart .cbe-pill{margin:8px 0 0}" +
    ".cbe-note{margin-top:8px;font-size:14px;font-weight:600;color:" + DANGER + "}" +
    ".cbe-note:empty{display:none}" +
    ".cbe-blocked{opacity:.45!important;cursor:not-allowed!important}" +
    ".cbe-hidden{display:none!important}" +
    ".cbe-cart{border:1px solid " + DANGER + ";border-radius:10px;padding:12px 14px;margin:0 0 14px;background:#fff;font-size:14px;line-height:1.4;color:#222;text-align:start}" +
    ".cbe-cart strong{display:block;color:" + DANGER + ";margin-bottom:6px}" +
    ".cbe-cart ul{margin:0 0 8px;padding-inline-start:18px;list-style:disc}" +
    "";
  document.head.appendChild(style);

  var PIN =
    '<svg class="cbe-pin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';

  var CHEVRON =
    '<svg class="cbe-chevron" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 3.5 5 6.5 8 3.5"/></svg>';

  var CHECK =
    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 8.5 6.5 12 13 4.5"/></svg>';

  // ── Своё выпадающее меню эмиратов ─────────────────────────────────────────
  // Системный <select> выглядел как список Windows/Android и был шире нужного.
  // Меню — один элемент на странице, крепится к body с position:fixed, чтобы
  // его не обрезала шапка; работает с клавиатуры (стрелки, Enter, Esc).
  var openMenu = null; // {menu, btn}

  function closeMenu(focusBack) {
    if (!openMenu) return;
    var m = openMenu;
    openMenu = null;
    m.menu.remove();
    m.btn.setAttribute("aria-expanded", "false");
    if (focusBack) m.btn.focus();
  }

  function placeMenu(menu, btn) {
    var r = btn.getBoundingClientRect();
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var vh = window.innerHeight;
    var w = Math.min(Math.max(r.width, 220), vw - 16);
    var left = lang === "ar" ? r.right - w : r.left;
    left = Math.min(Math.max(8, left), vw - w - 8);
    menu.style.width = w + "px";
    menu.style.left = left + "px";
    var h = menu.offsetHeight;
    var below = vh - r.bottom - 8;
    var top = below < h + 6 && r.top - 8 > h + 6 ? r.top - h - 6 : r.bottom + 6;
    menu.style.top = Math.max(8, top) + "px";
  }

  function showMenu(btn) {
    closeMenu(false);
    var menu = document.createElement("ul");
    menu.className = "cbe-menu";
    menu.setAttribute("role", "listbox");
    menu.setAttribute("aria-label", btn.getAttribute("aria-label") || T.emirate);
    if (lang === "ar") menu.setAttribute("dir", "rtl");
    EMIRATES.forEach(function (e) {
      var li = document.createElement("li");
      li.setAttribute("role", "option");
      li.setAttribute("aria-selected", String(e === btn.getAttribute("data-value")));
      li.setAttribute("data-value", e);
      li.tabIndex = -1;
      var t = document.createElement("span");
      t.textContent = name(e);
      li.appendChild(t);
      li.insertAdjacentHTML("beforeend", CHECK);
      menu.appendChild(li);
    });
    function pick(e) {
      closeMenu(true);
      btn.cbeSet(e);
      if (btn.cbeOnPick) btn.cbeOnPick(e);
    }
    menu.addEventListener("click", function (ev) {
      var li = ev.target.closest && ev.target.closest("li[data-value]");
      if (li) pick(li.getAttribute("data-value"));
    });
    menu.addEventListener("keydown", function (ev) {
      var items = all("li[data-value]", menu);
      var i = items.indexOf(document.activeElement);
      if (ev.key === "ArrowDown") { ev.preventDefault(); items[Math.min(items.length - 1, i + 1)].focus(); }
      else if (ev.key === "ArrowUp") { ev.preventDefault(); items[Math.max(0, i - 1)].focus(); }
      else if (ev.key === "Home") { ev.preventDefault(); items[0].focus(); }
      else if (ev.key === "End") { ev.preventDefault(); items[items.length - 1].focus(); }
      else if (ev.key === "Enter" || ev.key === " ") { ev.preventDefault(); if (i >= 0) pick(items[i].getAttribute("data-value")); }
      else if (ev.key === "Escape") { ev.preventDefault(); ev.stopPropagation(); closeMenu(true); }
      else if (ev.key === "Tab") { closeMenu(false); }
    });
    document.body.appendChild(menu);
    placeMenu(menu, btn);
    btn.setAttribute("aria-expanded", "true");
    openMenu = { menu: menu, btn: btn };
    var sel = menu.querySelector('[aria-selected="true"]') || menu.firstChild;
    try { sel.focus({ preventScroll: true }); } catch (err) { sel.focus(); }
  }

  // Клик или касание мимо меню, прокрутка страницы, поворот экрана — закрываем.
  document.addEventListener("pointerdown", function (ev) {
    if (!openMenu) return;
    if (openMenu.menu.contains(ev.target) || openMenu.btn.contains(ev.target)) return;
    closeMenu(false);
  }, true);
  window.addEventListener("scroll", function (ev) {
    if (openMenu && !(ev.target && ev.target.nodeType === 1 && openMenu.menu.contains(ev.target))) closeMenu(false);
  }, true);
  window.addEventListener("resize", function () { closeMenu(false); });

  /**
   * Кнопка выбора эмирата. opts.label — подпись «Доставка:» (вид «пилюли» для шапки);
   * без неё — поле во всю ширину для окна. onPick вызывается с выбранным эмиратом.
   */
  function makeDropdown(value, onPick, opts) {
    opts = opts || {};
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cbe-dd" + (opts.label ? " cbe-pill" : "");
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", (opts.label || T.emirate) + " " + name(value));
    btn.setAttribute("data-value", value);
    if (opts.label) {
      btn.insertAdjacentHTML("beforeend", PIN);
      var lab = document.createElement("span");
      lab.className = "cbe-label";
      lab.textContent = opts.label;
      btn.appendChild(lab);
    }
    var val = document.createElement("span");
    val.className = "cbe-val";
    val.textContent = name(value);
    btn.appendChild(val);
    btn.insertAdjacentHTML("beforeend", CHEVRON);
    btn.cbeOnPick = onPick;
    btn.cbeSet = function (e) {
      btn.setAttribute("data-value", e);
      btn.setAttribute("aria-label", (opts.label || T.emirate) + " " + name(e));
      val.textContent = name(e);
    };
    btn.addEventListener("click", function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      if (openMenu && openMenu.btn === btn) closeMenu(false);
      else showMenu(btn);
    });
    btn.addEventListener("keydown", function (ev) {
      if (ev.key === "ArrowDown" || ev.key === "ArrowUp") { ev.preventDefault(); showMenu(btn); }
    });
    return btn;
  }

  function makePicker(label) {
    var btn = makeDropdown(currentEmirate(), setEmirate, { label: label });
    if (lang === "ar") btn.classList.add("cbe-rtl");
    return btn;
  }

  function renderPickers() {
    // Шапка на компьютере: перед иконками избранного и корзины.
    var cart = document.getElementById("cart-icon-bubble");
    var icons = cart && cart.parentNode;
    if (icons && !icons.querySelector(":scope > .cbe-pill")) icons.insertBefore(makePicker(T.deliverTo), icons.firstChild);
    // Шапка на телефоне тесная — отдельная строка под ней, внутри липкой шапки.
    all("sticky-header-mobile .header-mobile__wrapper, .header-mobile .header-mobile__wrapper").forEach(function (wrap) {
      var next = wrap.nextElementSibling;
      if (next && next.classList.contains("cbe-strip")) return;
      var strip = document.createElement("div");
      strip.className = "cbe-strip";
      strip.appendChild(makePicker(T.deliverTo));
      wrap.parentNode.insertBefore(strip, wrap.nextSibling);
    });
    // Эмират сменили в другом меню (или в другой вкладке) — подтягиваем значение.
    // Поле в окне выбора не трогаем: там свой, ещё не подтверждённый выбор.
    var e = currentEmirate();
    all(".cbe-pill").forEach(function (b) { if (b.getAttribute("data-value") !== e && b.cbeSet) b.cbeSet(e); });
  }

  // ── Окно выбора при каждом новом визите ───────────────────────────────────
  function openWelcome(guess) {
    if (document.querySelector(".cbe-overlay")) return;
    markAsked();
    var overlay = document.createElement("div");
    overlay.className = "cbe-overlay" + (lang === "ar" ? " cbe-rtl" : "");
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    if (lang === "ar") overlay.setAttribute("dir", "rtl");
    var modal = document.createElement("div");
    modal.className = "cbe-modal";
    var h = document.createElement("h3"); h.id = "cbe-title"; h.textContent = T.title;
    overlay.setAttribute("aria-labelledby", "cbe-title");
    var p = document.createElement("p"); p.textContent = T.hint;
    var field = document.createElement("div");
    field.className = "cbe-field";
    var caption = document.createElement("small"); caption.textContent = T.emirate;
    var chosen = EMIRATES.indexOf(guess) >= 0 ? guess : DEFAULT_EMIRATE;
    var picker = makeDropdown(chosen, function (e) { chosen = e; });
    field.appendChild(caption); field.appendChild(picker);
    var save = document.createElement("button");
    save.type = "button";
    save.className = "cbe-save";
    save.textContent = T.save;

    // Esc закрывает сначала открытое меню, потом окно.
    function onKey(ev) { if (ev.key === "Escape" && !openMenu) close(); }
    // Любое закрытие сохраняет выбранный эмират (заранее стоит прошлый,
    // при первом визите — по IP или Дубай); в этот визит окно больше не появится.
    function close() {
      document.removeEventListener("keydown", onKey);
      closeMenu(false);
      overlay.remove();
      setEmirate(chosen);
    }
    save.addEventListener("click", close);
    overlay.addEventListener("click", function (ev) { if (ev.target === overlay) close(); });
    document.addEventListener("keydown", onKey);

    modal.appendChild(h); modal.appendChild(p); modal.appendChild(field); modal.appendChild(save);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    picker.focus();
  }

  // ── Остатки по складам ───────────────────────────────────────────────────
  var stock = {}; // productId -> {available, variants} | null (данных нет — не блокируем)
  var queued = {};
  var queueTimer = null;

  function request(ids) {
    ids.forEach(function (id) { if (id && !(id in stock)) queued[id] = true; });
    if (queueTimer || !Object.keys(queued).length) return;
    queueTimer = setTimeout(function () {
      queueTimer = null;
      var batch = Object.keys(queued);
      queued = {};
      batch.forEach(function (id) { stock[id] = undefined; }); // «в пути», повторно не просим
      for (var i = 0; i < batch.length; i += 60) {
        (function (chunk) {
          origFetch(API + "?products=" + chunk.join(","), { credentials: "omit" })
            .then(function (r) { return r.ok ? r.json() : { products: {} }; })
            .catch(function () { return { products: {} }; })
            .then(function (body) {
              chunk.forEach(function (id) { stock[id] = (body.products && body.products[id]) || null; });
              refreshAll();
            });
        })(batch.slice(i, i + 60));
      }
    }, 50);
  }

  /** Доступно на складе выбранного эмирата; null — данных нет. */
  function availableFor(productId, variantId) {
    var p = stock[productId];
    if (!p) return null;
    var s = (variantId && p.variants && p.variants[variantId]) || p.available;
    return s ? s[stockKey(currentEmirate())] : null;
  }

  // ── Формы «В корзину»: карточка товара, липкая панель, быстрый просмотр, каталог ──
  function digits(v) { return String(v == null ? "" : v).replace(/\D/g, ""); }

  function formInfo(form) {
    var pid = form.querySelector('[name="product-id"]');
    var holder = form.closest("[data-product-id]");
    var productId = digits((pid && pid.value) || (holder && holder.getAttribute("data-product-id")));
    var vid = form.querySelector('[name="id"]');
    // Количество у Ella иногда стоит вне формы; берём наибольшее из полей этого товара.
    var qty = 1;
    all('input[name="quantity"]', form)
      .concat(productId ? all('input[name="quantity"][data-product="' + productId + '"]') : [])
      .forEach(function (q) { qty = Math.max(qty, parseInt(q.value, 10) || 1); });
    return { productId: productId, variantId: vid ? digits(vid.value) : "", quantity: qty };
  }

  function block(el, on) {
    if (on === el.hasAttribute("data-cbe-blocked")) return;
    if (on) {
      el.setAttribute("data-cbe-blocked", el.disabled ? "was-disabled" : "1");
      el.disabled = true;
      el.classList.add("cbe-blocked");
    } else {
      if (el.getAttribute("data-cbe-blocked") !== "was-disabled") el.disabled = false;
      el.removeAttribute("data-cbe-blocked");
      el.classList.remove("cbe-blocked");
    }
  }

  function setText(el, text) { if (el.textContent !== text) el.textContent = text; }

  function refreshForms() {
    var forms = all('form[action*="/cart/add"]');
    request(forms.map(function (f) { return formInfo(f).productId; }));
    var emirate = name(currentEmirate());
    forms.forEach(function (form) {
      var buttons = all('button[name="add"], [data-btn-addToCart]', form);
      if (!buttons.length) return;
      var f = formInfo(form);
      var avail = f.productId ? availableFor(f.productId, f.variantId) : null;
      var short = avail !== null && avail < f.quantity;
      buttons.forEach(function (b) { block(b, short); });
      all(".shopify-payment-button, .productView-payment", form).forEach(function (el) {
        if (el.classList.contains("cbe-hidden") !== short) el.classList.toggle("cbe-hidden", short);
      });
      // Подпись — на основной форме товара; в каталоге и липкой панели хватает неактивной кнопки.
      var wrap = form.querySelector(".product-form__buttons");
      if (!wrap) return;
      var note = wrap.nextElementSibling;
      if (!note || !note.classList.contains("cbe-note")) {
        note = document.createElement("div");
        note.className = "cbe-note";
        note.setAttribute("role", "status");
        wrap.parentNode.insertBefore(note, wrap.nextSibling);
      }
      setText(note, !short ? "" : avail > 0 ? fmt(T.onlyLeft, { n: avail, emirate: emirate }) : fmt(T.out, { emirate: emirate }));
    });
  }

  // Страховка: скрипт темы мог снова включить кнопку при смене варианта.
  document.addEventListener(
    "click",
    function (ev) {
      var btn = ev.target.closest && ev.target.closest("[data-cbe-blocked]");
      if (btn) { ev.preventDefault(); ev.stopImmediatePropagation(); }
    },
    true
  );

  // ── Корзина ──────────────────────────────────────────────────────────────
  var cartItems = [];
  var cartAttribute = null;
  var shortages = [];
  var CHECKOUT = '#cart-checkout, .button-checkout, [data-href="/checkout"], button[name="checkout"], a[href*="/checkout"]';

  function refreshCart() {
    // С префиксом языка (/ru/, /ar/) — тогда названия товаров в предупреждении переведены.
    return origFetch(ROOT + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartItems = cart.items || [];
        cartAttribute = (cart.attributes && cart.attributes[CART_ATTRIBUTE]) || null;
        request(cartItems.map(function (it) { return String(it.product_id); }));
        if (cartItems.length && cartAttribute !== currentEmirate()) syncCartAttribute();
        refreshAll();
      })
      .catch(function () { /* корзина недоступна — ничего не блокируем */ });
  }

  function computeShortages() {
    var qty = {};
    cartItems.forEach(function (it) { qty[it.variant_id] = (qty[it.variant_id] || 0) + it.quantity; });
    var seen = {};
    var out = [];
    cartItems.forEach(function (it) {
      if (seen[it.variant_id]) return;
      seen[it.variant_id] = true;
      var a = availableFor(String(it.product_id), String(it.variant_id));
      if (a !== null && a < qty[it.variant_id]) {
        var title = it.product_title + (it.variant_title && it.variant_title !== "Default Title" ? " — " + it.variant_title : "");
        out.push({ title: title, available: a });
      }
    });
    return out;
  }

  function renderCartWarning() {
    shortages = computeShortages();
    var emirate = currentEmirate();
    var signature = emirate + "|" + JSON.stringify(shortages);
    // Страница корзины — над кнопками итога; боковая корзина — вверху списка.
    var hosts = all("form[action$='/cart'] .cart-actions, #halo-cart-sidebar .halo-sidebar-wrapper");
    hosts.forEach(function (host) {
      var box = host.querySelector(":scope > .cbe-cart");
      if (!shortages.length) { if (box) box.remove(); return; }
      if (box && box.getAttribute("data-sig") === signature) return;
      if (!box) { box = document.createElement("div"); box.className = "cbe-cart"; host.insertBefore(box, host.firstChild); }
      box.setAttribute("data-sig", signature);
      box.setAttribute("role", "alert");
      box.innerHTML = "";
      var title = document.createElement("strong");
      title.textContent = fmt(T.cartTitle, { emirate: name(emirate) });
      var ul = document.createElement("ul");
      shortages.forEach(function (s) {
        var li = document.createElement("li");
        li.textContent = s.title + " — " + (s.available > 0 ? fmt(T.cartLeft, { n: s.available }) : T.cartNone);
        ul.appendChild(li);
      });
      var hint = document.createElement("div");
      hint.textContent = T.cartHint;
      box.appendChild(title); box.appendChild(ul); box.appendChild(hint);
      box.appendChild(makePicker(T.change));
    });
    var blocked = shortages.length > 0;
    all(CHECKOUT).forEach(function (btn) {
      if (btn.classList.contains("cbe-blocked") !== blocked) btn.classList.toggle("cbe-blocked", blocked);
      if (btn.getAttribute("aria-disabled") !== String(blocked)) btn.setAttribute("aria-disabled", String(blocked));
    });
    // Экспресс-оплата (Apple Pay и т.п.) в корзине минует кнопку оформления — прячем её тоже.
    all(".cart-actions .additional-checkout-buttons, #halo-cart-sidebar .additional-checkout-buttons").forEach(function (el) {
      if (el.classList.contains("cbe-hidden") !== blocked) el.classList.toggle("cbe-hidden", blocked);
    });
  }

  document.addEventListener(
    "click",
    function (ev) {
      var btn = ev.target.closest && ev.target.closest(CHECKOUT);
      if (!btn) return;
      // Считаем заново: отрисовка могла ещё не пройти (например, в фоновой вкладке).
      shortages = computeShortages();
      if (!shortages.length) return;
      renderCartWarning();
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var box = all(".cbe-cart").filter(function (b) { return b.offsetParent !== null; })[0];
      if (box) box.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    true
  );
  // Форма корзины может уйти на оформление и без клика (Enter в поле количества).
  document.addEventListener(
    "submit",
    function (ev) {
      var form = ev.target;
      if (!form.matches || !form.matches("form[action$='/cart']")) return;
      shortages = computeShortages();
      if (!shortages.length) return;
      var submitter = ev.submitter;
      if (!submitter || submitter.matches(CHECKOUT)) { ev.preventDefault(); ev.stopImmediatePropagation(); }
    },
    true
  );

  function syncCartAttribute() {
    var e = currentEmirate();
    if (cartAttribute === e) return;
    cartAttribute = e;
    var attributes = {};
    attributes[CART_ATTRIBUTE] = e;
    origFetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () { cartAttribute = null; });
  }

  // Корзину меняют скрипты темы (добавление, количество, удаление) — после
  // каждого такого запроса перечитываем её.
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var result = origFetch.apply(null, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      result.then(function () { setTimeout(refreshCart, 300); }).catch(function () {});
    }
    return result;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) {
      this.addEventListener("loadend", function () { setTimeout(refreshCart, 300); });
    }
    return origOpen.apply(this, arguments);
  };

  // ── Обновление ───────────────────────────────────────────────────────────
  // Таймер, а не requestAnimationFrame: во фоновой вкладке rAF не срабатывает,
  // и корзина осталась бы без проверки.
  var pendingRefresh = 0;
  function refreshAll() {
    if (pendingRefresh) return;
    pendingRefresh = setTimeout(function () {
      pendingRefresh = 0;
      renderPickers();
      refreshForms();
      renderCartWarning();
    }, 16);
  }

  /** Эмират по IP; за 2,5 с не ответили или не ОАЭ — null. */
  function geoGuess() {
    var timeout = new Promise(function (resolve) { setTimeout(function () { resolve(null); }, 2500); });
    var ask = fetch(GEO_API)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (body) { return body && EMIRATES.indexOf(body.emirate) >= 0 ? body.emirate : null; })
      .catch(function () { return null; });
    return Promise.race([ask, timeout]);
  }

  function start() {
    refreshAll();
    refreshCart();
    // Спрашиваем эмират при каждом новом визите. Уже выбирали — заранее стоит
    // прошлый эмират; первый визит — подсказка по IP.
    if (!askedThisVisit()) {
      var shownAt = Date.now();
      var known = stored();
      (known ? Promise.resolve(known) : geoGuess()).then(function (guess) {
        setTimeout(function () { openWelcome(guess); }, Math.max(0, 800 - (Date.now() - shownAt)));
      });
    }
    // Вариант меняется записью в скрытое поле без событий — сверяемся раз в секунду.
    setInterval(refreshForms, 1000);
    // Быстрый просмотр, подгрузка каталога, перерисовка боковой корзины.
    new MutationObserver(refreshAll).observe(document.body, { childList: true, subtree: true });
    window.addEventListener("pageshow", function (ev) { if (ev.persisted) refreshCart(); });
    window.addEventListener("storage", function (ev) { if (ev.key === STORAGE_KEY) { syncCartAttribute(); refreshAll(); } });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
